<template>
  <div class="top_operation" @click="handleClaerActive">
    <div class="flex_item top-left-toolbar">
      <div
        class="control-button-top theme-color active"
        v-for="(item, index) in leftDataSource.children"
        :key="'control-button' + index"
      >
        <el-dropdown trigger="click" class="page-list-dropdown" @command="handleCommand">
          <span class="el-dropdown-link colfff8">
            {{ curPageName }}
            <i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="page-list scrollbar">
            <el-dropdown-item
              class="overflowHid2"
              :key="idx"
              v-for="(item, idx) in pagelist"
              :class="pageId === item.publicId ? 'active' : ''"
              :command="idx"
            >
              {{ item.name }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <router-link :to="{ path: '/bigScreenList', query: { p: urlP, w: urlW } }" class="page-set fs14 baseTopColor"
        >页面管理</router-link
      >
    </div>
    <div class="flex_item device-item">
      <div class="device-size-item">
        <label>页面：</label>
        {{ width }} x {{ height }}
        <span class="icon-portal-setting1 theme-color" @click.stop="pageSettingMode"></span>
      </div>
    </div>
    <div class="flex_item content-r top-right-toolbar">
      <div class="flex_item page_handle_btns">
        <div class="control-button" @click.stop="replacePageClick">
          <span class="icon icon-portal-replace-page"></span>
          <p class="keep-all">替换页面</p>
        </div>
      </div>
      <div class="flex_item page_handle_btns">
        <div
          class="control-button"
          @click.stop="clearAllRect"
          @mouseover="mouseover = true"
          @mouseleave="mouseover = false"
        >
          <span :class="['icon', 'icon-portal-clear', mouseover ? 'mouseover' : '']"></span>
          <p class="keep-all">清空内容</p>
        </div>
      </div>
      <div class="flex_item page_handle_btns">
        <div class="control-button" @click.stop="saveToTemplate">
          <span class="icon icon-portal-backstage"></span>
          <p class="keep-all">设为模板</p>
        </div>
      </div>
      <div class="flex_item page_handle_btns">
        <div class="control-button" @mouseenter.prevent="showTools = true" @mouseleave.prevent="showTools = false">
          <span class="icon icon-portal-page-template"></span>
          <p class="keep-all">显示</p>
          <span v-show="simpleMode" class="icon-portal-arrows-right right-icon"></span>
          <span class="icon-portal-arrows-right down-icon"></span>
          <ul class="pull-down-lists" v-show="showTools">
            <li class="pull-down-list" @click.stop="changeRulerStatu">
              <span class="selected-icon" :class="showRuler ? 'icon-portal-check-small' : ''"></span>显示标尺
            </li>
            <li class="pull-down-list" @click="showLeftMenus = !showLeftMenus">
              <span class="selected-icon" :class="showLeftMenus ? 'icon-portal-check-small' : ''"></span>显示左侧面板
            </li>
            <li class="pull-down-list" @click="showRightToolbar = !showRightToolbar">
              <span class="selected-icon" :class="showRightToolbar ? 'icon-portal-check-small' : ''"></span>显示右侧面板
            </li>
          </ul>
        </div>
      </div>
      <div class="flex_item handle-groups-second">
        <el-tooltip v-if="canGoBack" effect="dark" content="撤销" placement="bottom">
          <div class="control-button left-cutting-line" @click.stop="goBackHandel">
            <span class="icon icon-portal-return"></span>
          </div>
        </el-tooltip>
        <div v-else class="control-button left-cutting-line disabled" @click.stop>
          <span class="icon icon-portal-return"></span>
        </div>
        <el-tooltip v-if="canGoNext" effect="dark" content="恢复" placement="bottom">
          <div class="control-button" @click.stop="goNextHandel">
            <span class="icon icon-portal-go-on"></span>
          </div>
        </el-tooltip>
        <div v-else class="control-button disabled" @click.stop>
          <span class="icon icon-portal-go-on"></span>
        </div>
      </div>
      <div class="flex_item">
        <div class="control-button" @click.stop="clickPreview">
          <el-button class="preview">预览</el-button>
        </div>
        <div class="control-button" @click.stop="clickSave">
          <el-button class="save">保存</el-button>
        </div>
      </div>
    </div>

    <!-- 设为模板对话框 -->
    <el-dialog title="设为模板" :modal-append-to-body="false" :visible.sync="setTempLateDialog" width="30%">
      <el-form :model="form" label-width="80px">
        <el-form-item label="模板名称">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <p class="fs12" style="text-align: left; margin: 6px 0 0 12px">
          将此屏保存为模板后，对此屏的修改将会同步至模板
        </p>
      </el-form>
      <div style="margin-top: 16px">
        <el-button @click="setTempLateDialog = false">取 消</el-button>
        <el-button type="primary" @click="postTemplateData">保 存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="替换页面"
      :modal-append-to-body="false"
      :visible.sync="replacePageDialog"
      custom-class="replaceDialog"
      width="800px"
    >
      <span slot="title" class="dialog-title" v-if="showSubPage">
        <div class="return-btn" @click="showSubPage = false"><i class="icon-portal-arrows-left"></i>{{ pageTitle }}</div>
      </span>
      <p class="fs14 textColor" v-if="!showSubPage">选择模板替换当前页面</p>
      <ul class="templates-types" v-if="!showSubPage">
        <li
          :class="type.encId === activeTemplateId ? 'active' : ''"
          v-for="(type, index) in pageTemplateType"
          :key="'type_' + index"
          @click="changeTemplateType(type)"
        >
          {{ type.name }}
        </li>
      </ul>
      <ul class="pages-styles" v-if="!showSubPage">
        <li
          v-for="(item, index) in pageTemplates"
          :class="templatePageId === item.encId ? 'active' : ''"
          :key="index"
          @click="selectSubPage(item, index)"
        >
          <div class="cover-box">
            <img
              v-if="templatePageId === item.encId"
              class="checked"
              src="../../assets/images/icon-checked.png"
              alt=""
            />
            <img class="page-img" :src="item.cover || defaultImgSrc" />
          </div>
          <p class="textColor">{{ item.name }}</p>
        </li>
      </ul>
      <ul class="pages-styles marginTop0 maxHeight500" v-if="showSubPage">
        <li
          v-for="(item, index) in subPageTemplate"
          :class="subTemplatePageId === item.encId ? 'active' : ''"
          :key="index"
          @click="selectTemplatePage(item, index)"
        >
          <div class="cover-box">
            <img
              v-if="subTemplatePageId === item.encId"
              class="checked"
              src="../../assets/images/icon-checked.png"
              alt=""
            />
            <img class="page-img" :src="item.cover || defaultImgSrc" />
          </div>
          <p class="textColor">{{ item.name }}</p>
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="replacePageDialog = false">取 消</el-button>
        <el-button size="small" type="primary" @click="nextClick()" v-if="!showSubPage">确 定</el-button>
        <el-button size="small" type="primary" @click="saveReplacePage('')" v-else>确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<style scoped>
.icon-portal-clear::before {
  font-size: 19px;
}
.mouseover::before {
  color: var(--themeColor);
}
.select/deep/ .el-scrollbar__wrap {
  margin-bottom: -19px !important;
  margin-right: -19px !important;
}
</style>
<style lang="scss" scoped>
* {
  margin: 0;
}
.page-set:hover {
  color: var(--themeColor);
}
.keep-all {
  word-break: keep-all;
}
.top_operation {
  width: 100%;
  min-width: 1280px;
  height: 60px;
  display: flex;
  padding: 0 20px;
  box-sizing: border-box;
  justify-content: space-between;
  position: fixed;
  top: 0;
  background: #2d3136;
  z-index: 1000;
  text-align: center;
  color: rgba(255, 255, 255, 0.8);
  .top-left-toolbar,
  .top-right-toolbar {
    width: 40%;
  }
  .device-item {
    width: 20%;
    color: rgba(255, 255, 255, 0.6);
  }
}
.flex_item {
  display: flex;
  align-items: center;
}
.page_handle_btns .control-button {
  min-width: 70px;
  padding: 12px 5px;
  text-align: center;
}
.top-left-toolbar {
  line-height: 60px;
  margin-left: 10px;
}
.top-right-toolbar > .flex_item {
  margin: 0 10px;
}

.control-button {
  position: relative;
  min-width: 60px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 14px;
  .icon {
    font-size: 20px;
  }
  &.disabled {
    cursor: not-allowed;
    .icon::before {
      color: #606266;
    }
  }
  .preview {
    width: 80px;
    height: 32px;
    padding: 0;
    line-height: 32px;
    background: transparent;
    color: var(--themeColor);
    border: 1px solid var(--themeColor);

    &:hover {
      background: rgba(61, 130, 242, 0.1);
    }
  }

  .save {
    width: 80px;
    padding: 0;
    height: 32px;
    line-height: 32px;
    background-color: var(--themeColor);
    border: 1px solid var(--themeColor);
    color: #fff;

    &:hover {
      background: rgba(61, 130, 242, 0.8);
    }
  }
}

.handle-groups-second .control-button {
  min-width: 50px;
}

.top-right-toolbar {
  .control-button {
    &:hover {
      color: var(--themeColor);
    }
  }
}
.control-button.active {
  color: var(--themeColor);
}

.control-button.unactive {
  color: #ccc;
}

.baseTopColor {
  color: var(--themeColor);
  margin-left: 8px !important;
}
.fsTitle {
  color: rgba(255, 255, 255, 0.8);
}

.control-button-top {
  min-width: auto;
}

.pages {
  position: relative;
  z-index: 9997;
}
.device-size-item {
  cursor: pointer;
}
.add-page-btn {
  padding: 16px;
  box-sizing: border-box;
  cursor: pointer;

  .icon {
    margin-right: 4px;
  }
}
::v-deep .el-select .el-input__inner {
  background-color: transparent;
  border: none;
  width: 120px;
}
::v-deep .el-select .el-input__suffix {
  display: none;
}
.page-list {
  width: 200px;
  max-height: 400px;
  overflow-y: auto;
}
.page-list li {
  min-height: 24px;
  line-height: 22px;
  font-size: 16px;
  padding: 8px;
}
.page-list .el-dropdown-menu__item.active,
.page-list .el-dropdown-menu__item:focus,
.page-list .el-dropdown-menu__item:not(.is-disabled):hover {
  background: transparent;
}
</style>

<script>
import { getErrorMessage } from "utils/errorMessageMap.js"
import {
  _throttle,
  _debounce,
  encryption,
  PXRESEVERPROP,
  getAttrById,
  mhxssEncodeFunc,
  getAllColsUidInLayoutComponent,
  handleFindLayoutComponentOptions
} from "../../utils/index"
import { GetRequest } from "../../utils/initUrlQueryData"
import { data_dictionary_map } from "../../../static/dataDictionary"
import instance from "../../interceptor"
export default {
  name: "top-operation",
  props: {
    headerSource: { type: Array, default: [] }
  },
  data: function () {
    return {
      mouseover: false,
      form: {
        name: ""
      },
      leftDataSource: this.headerSource[0],
      centerDataSource: this.headerSource[1],
      rightDataSource: this.headerSource[2],
      isHandleData: false,
      MAX_STEPS: 10, //记录的最大步骤
      isLock: false,
      selectedLanguage: 0,
      // selectedPageInedex: 0,
      showPagesList: false,
      showLanguageList: false,
      languageLists: [
        {
          icon: "icon-portal-chinese-one",
          name: "简体中文"
        },
        {
          icon: "icon-portal-english",
          name: "英语"
        },
        {
          icon: "icon-portal-french",
          name: "法语"
        }
      ],
      timer: null,
      totalTime: 0,
      steps: [],
      recoverStep: [],
      pagelist: [],
      pageIndex: 0,
      curPageName: "",
      setTempLateDialog: false,
      urlP: undefined,
      urlW: undefined,
      showTools: false,
      simpleMode: false, //头部菜单是不是简略模式
      dialogObject: null,
      replacePageDialog: false,
      pageTemplates: [],
      pageTemplateType: [],
      activeTemplateId: "78A9CCC5337333FC",
      templatePageId: "",
      showSubPage: false,
      pageTitle: "",
      subTemplatePageId: "",
      subPageTemplate: [],
      defaultImgSrc: require("../../assets/images/default_image.png"),
      isCurrentPage: true,
      autoSaveTimer: null
    }
  },
  created() {
    setTimeout(() => {
      this.getPageList()
    }, 1000)
    this.urlW = GetRequest().w
    this.urlP = GetRequest().p
  },
  mounted() {
    if (localStorage.getItem("useLocalTemplate")) {
      localStorage.removeItem("useLocalTemplate")
    }
    this.managerType = GetRequest().admin ? 1 : 0
    this.pageTabChange()
    this.$nextTick(() => {
      this.autoSave()
    })
  },
  computed: {
    isLayout() {
      return this.$store.state[this.request_prefix].page.pageLayoutType
    },
    dataSource() {
      return JSON.parse(JSON.stringify(this.$store.state[this.request_prefix]))
    },
    width() {
      return this.dataSource.page.stageType === "layOut"
        ? this.dataSource.page.pageWidth
        : this.dataSource.page.children[0].width
    },
    height() {
      return this.dataSource.page.stageType === "layOut"
        ? this.dataSource.page.height
        : this.dataSource.page.children[0].height
    },
    activeId() {
      return this.$store.state.states.activeID
    },
    pageId() {
      return this.$store.state.states.getDataPageIds.pageId
    },
    websiteId() {
      return this.$store.state.states.getDataPageIds.websiteId
    },
    showRuler: {
      get() {
        return this.$store.state.states.showRuler
      },
      set(newVal) {
        this.$store.commit("states/changeShowRulerStatus", newVal)
      }
    },
    showLeftMenus: {
      get() {
        return this.$store.state.states.showLeftMenus
      },
      set(newVal) {
        this.$store.commit("states/changeShowLeftMenusStatus", newVal)
      }
    },
    showRightToolbar: {
      get() {
        return this.$store.state.states.showRightToolbar
      },
      set(newVal) {
        this.$store.commit("states/changeShowRightToolbarStatus", newVal)
      }
    },
    managerType: {
      get() {
        return this.$store.state.states.managerType
      },
      set(val) {
        // this.$changePageAttribute({ option_name: "managerType", option_val: val })
        this.$store.commit("states/changeManagerType", Number(val))
      }
    },
    historyList() {
      return this.$store.state.states.historyState
    },
    canGoBack() {
      return this.$store.state.states.historyIndex >= 0
    },
    canGoNext() {
      const { historyIndex, historyState } = this.$store.state.states
      return historyIndex < historyState.length - 1
    },
  },
  watch: {
    dataSource: {
      handler(newVal, oldVal) {
        var newValDiff, oldValDiff
        // 撤销和恢复造成的数据改变
        if (this.isHandleData) {
          this.isHandleData = false
          return
        }
        // 排除掉是不是只是激活了组件
        if (
          typeof this.activeId.container_id === "number" &&
          !isNaN(this.activeId.container_id) &&
          typeof this.activeId.rect_id === "number" &&
          !isNaN(this.activeId.rect_id)
        ) {
          newValDiff = getAttrById(newVal, this.activeId, "rect")
          if (oldVal) {
            oldValDiff = getAttrById(oldVal, this.activeId, "rect")
          }
          if (newValDiff && oldValDiff && newValDiff.active !== oldValDiff.active) {
            return
          }
        }

        let param = oldVal
        this.recoverStep = []
        if (this.steps.length < this.MAX_STEPS) {
          this.steps.push(param)
        } else {
          this.steps.splice(0, 1).push(param)
        }
        if (
          this.$store.state.operation.operation.children[2].children[1].isActive !== true ||
          this.$store.state.operation.operation.children[2].children[2].isActive !== false
        ) {
          this.$store.commit("operation/SET_ACTIVE_STATU", {
            index: 1,
            statu: true
          })
          this.$store.commit("operation/SET_ACTIVE_STATU", {
            index: 2,
            statu: false
          })
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    pageSettingMode(ev) {
      this.$store.commit("states/changeElementType", "page")
      let isFold = document.getElementsByClassName("right-toolbar-wrap")[0].classList.contains("fold")
      if(isFold){
        document.getElementsByClassName("right-toolbar ")[0].getElementsByClassName("fold-btn")[0].click()
      }
    },
    changeStageLayout(layout) {
      console.log(layout)
    },
    saveToTemplate() {
      this.setTempLateDialog = true
    },

    clearAllRect() {
      this.$confirm("清空内容后页面内的所有组件将会消失, 是否继续?", "", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        showClose: false,
        iconClass: `${this.request_prefix}_confirm_icon el-icon-warning`,
        cancelButtonClass: `${this.request_prefix}_confirm_cancel_button`,
        confirmButtonClass: `${this.request_prefix}_confirm_button`,
        customClass: `${this.request_prefix}_confirm custom_warning_dialog`
      })
        .then(() => {
          if (this.isLayout) {
            this.$store.commit("states/changeElementType", null)
          } else {
            this.$store.commit("states/changeActiveID", { container_id: 0 })
            this.$store.commit("states/changeElementType", "bigScreenContainer")
          }
          this.$store.dispatch(this.request_prefix + "/clearAllRect")
          this.$store.commit("states/changeIsUpdateLayerDataFlag", true)
          this.$store.commit("states/clearHistoryState")
          this.$message({
            type: "success",
            duration: 2000,
            message: "清空成功!"
          })
        })
        .catch(action => {
          if (action === "cancel") return
          this.$message({
            type: "info",
            message: "清空失败"
          })
        })
    },
    postTemplateData() {
      this.setTempLateDialog = false
      if (!this.form.name.trim().length) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          message: "模板名称不能为空！",
          type: "warning"
        })
        return
      }
      if (this.form.name.trim().length > 50) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          message: "模板名称过长 请修改名称后重新保存",
          type: "warning"
        })
        return
      }
      this.$API
        .setMyTemplate({
          websiteId: this.$route.query.w,
          param: {
            name: this.form.name,
            typeId: 199
          }
        })
        .then(res => {
          if (res.data.status !== 200 || res.data.code === 0) {
            return Promise.reject({ message: res?.data?.message })
          }
          this.form.name = ""
          this.$message({
            customClass: "bigScreen_msg_backGroud",
            type: "success",
            message: "保存成功"
          })
        })
        .catch(err => {
          this.$message({
            type: "error",
            customClass: "bigScreen_msg_backGroud",
            message: getErrorMessage(err?.message, true) || "保存失败"
          })
        })
    },
    getPageList() {
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_csontextpath"] : ""
      const { websiteId, pageId, sign, wfwfid } = this.$store.state.states.getDataPageIds
      this.$API.queryEditPageList({ websiteId: websiteId, pageId: pageId }).then(res => {
        if (res.data.code === 1) {
          this.pagelist = res.data.data.pageList
          this.$store.commit("states/changePageList", this.pagelist)
          for (let i = 0; i < this.pagelist.length; i++) {
            if (this.pagelist[i].publicId == this.pageId) {
              this.curPageName = this.pagelist[i].name
              document.title = this.curPageName
              break
            }
          }
        }
      })
    },
    handleClaerActive: _throttle(function () {
      // this.$store.commit("states/changeElementType", null)
      this.$store.commit("states/changeActiveID", { container_id: 0 })
      this.$store.commit("states/changeElementType", "bigScreenContainer")
      this.$store.commit("states/changeToolBarStatus", false)
      this.$store.commit("states/changeAlignHelperStatus", false)
    }, 500),
    switchDevice: function (item, index) {
      this.$store.dispatch("operation/setActive", { id: index })
      if (index === 1 && this.$route.path !== "/appHome") {
        this.$router.push("/appHome")
      } else if (this.$route.path !== "/home" && index !== 1) {
        this.$router.push("/home")
      }
    },
    alignEv() {
      //对其辅助事件处理函数，需要选择一个主元素作为从元素的带领元素。

      //未选中任何组件，进行警告弹窗
      if (this.activeId.container_id === null) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "请选择一个主元素",
          type: "warning"
        })
        return
      }
      //选择了一级组件，没选中布局组件中的组件
      if (this.activeId.container_id !== null && this.activeId.elementInLayoutId === null) {
        this.$store.commit("states/changeAlignHelperStatus", true)
        this.$store.commit("states/changeToolBarStatus", true)
        this.handle1stLevelAlign()
        return
      }
      if (this.activeId.elementInLayoutId !== null) {
        this.$store.commit("states/changeAlignHelperStatus", true)
        this.$store.commit("states/changeToolBarStatus", true)
        this.handleElementInLayoutAlign()
        return
      }
    },
    handle1stLevelAlign() {
      console.log("choose 1st level component")
    },
    handleElementInLayoutAlign() {
      console.log("choose elementInLayout component")
    },
    // 根据url的键名获取值
    getUrlParam(name) {
      var reg = new RegExp("[?&]" + name + "=([^&#]+)")
      var query = window.location.href.match(reg)
      return query ? query[1] : null
    },
    // 点击保存按钮进行保存
    clickSave($event, ifAutoSave) {
      let lastTime = sessionStorage.getItem("saveTime")
      let newTime = Date.now()
      sessionStorage.setItem("saveTime", newTime)
      // 3秒之内只能操作一次
      if ((newTime - lastTime) / 1000 < 3) {
        if (this.dialogObject || ifAutoSave) {
          //保存中
          return
        }
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "操作太频繁,请稍后再试",
          type: "error"
        })
      } else {
        this.save(ifAutoSave)
      }
    },
    // 保存
    save(ifAutoSave) {
      if (ifAutoSave) {
        this.dialogObject = true
      } else {
        this.dialogObject = this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 0,
          message: "保存中...",
          iconClass: "custom-loading icon-portal-loading1"
        })
        // 保存之前清除active状态  去掉保存的时候情况激活状态  改为进入页面先清空激活状态
        this.handleClaerActive()
      }
      // this.$store.dispatch(this.request_prefix + "/unsetActive", this.activeId)
      const _self = this
      // let param = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix]))
      let param = this.richTextReplace(this.request_prefix)
      /*... 处理背景变成白色的问题*/
      let thisUrl = window.location.href
      if (thisUrl.indexOf("deleteBackground") > -1) {
        delete param.page.children[0].options.background
      }
      // 开启新的布局模式
      if (_self.getUrlParam("isPageLayout") === "true") {
        param.page.pageLayoutType = "layOut"
      }
      /*...*/
      param.version = param.version ? param.version + 1 : 1
      param.type = param.type ? param.type : "bigScreen"
      delete param.page.cacheAppIds //删除无用数据结构
      delete param.page.nocacheAppIds //删除无用数据结构
      //将事件保存到webJson
      console.log("this.$event.allEvents() :>> ", this.$event.allEvents())
      param.event = this.$event.allEvents()

      const portalData = {
        encPageId: this.$store.state.states.getDataPageIds.pageId,
        list: 1,
        domain: "138498cvm",
        w: this.$store.state.states.getDataPageIds.websiteId
      }
      portalData.app = 0
      this.buildModelForBigScreen(param)
      const temp = JSON.parse(encryption(param, data_dictionary_map))
      portalData.content = temp
      /**
       * 如果需要向后台传递网页json，使用该方法加密后传递
       */
      portalData.content.page = JSON.parse(JSON.stringify(portalData.content.page).replace(/&quot;/g, "&qquot;"))
      this.$API
        .saveWebJson({
          app: portalData.app,
          webJson: portalData
        })
        .then(res => {
          if (_self.isLatestVersion(res.data.message)) {
            _self.$store.dispatch(this.request_prefix + "/changeVersion")
          }
          if (typeof this.dialogObject === "object") {
            this.dialogObject.close()
          }
          this.dialogObject = null
          // 自动保存成功  去掉toast
          if (!ifAutoSave) {
            this.$message({
              customClass: "bigScreen_msg_backGroud",
              duration: 3000,
              message: "保存成功",
              type: "success"
            })
          }
          this.autoSave()
        })
        .catch(err => {
          // dialog.close()
          if (typeof this.dialogObject === "object") {
            this.dialogObject.close()
          }
          this.dialogObject = null
          this.$message({
            // message: getErrorMessage(err?.message, true) || "保存失败",
            message: err.message === "非法访问" ? "请登录后操作" : err.message || "保存失败",
            customClass: "bigScreen_msg_backGroud",
            duration: 3000,
            type: "error"
          })
        })
    },
    // 富文本处理
    richTextReplace(request_prefix) {
      let paramTemp = JSON.parse(JSON.stringify(this.$store.state[request_prefix]))
      for (let i = 0; i < paramTemp.page.children.length; i++) {
        const container = paramTemp.page.children[i]
        for (let j = 0; j < container.children.length; j++) {
          const rect = container.children[j]
          // 查找自由布局中文本组件
          if (rect.shape === "layoutComponentBigScreen" || rect.shape === "emptyLayoutComponent") {
            let pOptions = rect.options.rows
            let colsIdFromActiveRect = getAllColsUidInLayoutComponent(pOptions)
            for (let i = 0; i < colsIdFromActiveRect.length; i++) {
              let tempUid = colsIdFromActiveRect[i]
              let elementInlayout = handleFindLayoutComponentOptions(pOptions, tempUid)
              for (let j = 0; j < elementInlayout.length; j++) {
                if (elementInlayout[j].innerElement === "cxText") {
                  // 对文本进行空格箭头替换处理
                  /*兼容值为0或者数字的情况*/
                  let dataStr = elementInlayout[j].content
                  if (dataStr === 0 || typeof dataStr === "number") {
                    dataStr = dataStr + ""
                  }
                  let content = mhxssEncodeFunc(dataStr, true)
                  this.$changeOptionsEV(content, "content", false, null, {
                    container_id: container.container_id,
                    rect_id: rect.rect_id,
                    uid: tempUid,
                    elementInLayoutId: elementInlayout[j].elementInLayoutId
                  })
                }
              }
            }
          }
        }
      }
      let param = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix]))
      this.handleTabActive(param)
      return param
    },
    clickPreview() {
      let lastTime = sessionStorage.getItem("scanTime")
      let newTime = Date.now()
      sessionStorage.setItem("scanTime", newTime)
      // 3秒之内只能操作一次
      if ((newTime - lastTime) / 1000 < 3) {
        this.$message({
          customClass: "bigScreen_msg_backGroud",
          duration: 3000,
          message: "操作太频繁,请稍后再试",
          type: "error"
        })
      } else {
        this.preview()
      }
    },
    // 预览
    preview() {
      this.handleClaerActive()
      const _self = this
      // let param = JSON.parse(JSON.stringify(this.$store.state[this.request_prefix]))
      let param = this.richTextReplace(this.request_prefix)
      param.version++
      //将事件保存到webJson
      console.log("this.$event.allEvents() :>> ", this.$event.allEvents())
      param.event = this.$event.allEvents()
      const portalData = {
        encPageId: this.$store.state.states.getDataPageIds.pageId,
        list: 1,
        domain: "138498cvm",
        w: this.$store.state.states.getDataPageIds.websiteId
      }
      portalData.app = 0
      this.buildModelForBigScreen(param)
      const temp = encryption(param, data_dictionary_map)
      portalData.content = temp
      portalData.content = portalData.content.replace(/&quot;/g, "&qquot;")
      /**
       * 如果需要向后台传递网页json，使用该方法加密后传递
       */
      const _this = this
      _this.$API
        .previewPage({
          app: portalData.app,
          webJson: portalData
        })
        .then(res => {
          if (_self.isLatestVersion(res.data.message)) {
            _self.$store.dispatch(this.request_prefix + "/changeVersion")
          }
          _this.timer = new Date().getTime()
          window.open(`${location.origin}/v2/p/${this.$store.state.states.getDataPageIds.pageId}`)
        })
        .catch(err => {
          console.log(err)
        })
    },
    requestLoop(url, portalData) {
      const _this = this
      _this.instance.get(`v2/webjson/${portalData.pageId}/html-status?a=${portalData.app}`).then(res => {
        const timer2 = new Date().getTime()
        if (res.data.code == 1) {
          window.open(url)
        } else {
          if (_this.totalTime < 10000) {
            if (timer2 - _this.timer < 3000) {
              let newt = 3000 - (timer2 - _this.timer)
              _this.totalTime += newt
              setTimeout(function () {
                _this.timer = new Date().getTime()
                _this.requestLoop(url, portalData)
              }, newt)
            } else {
              _this.totalTime += timer2 - _this.timer
              _this.timer = new Date().getTime()
              _this.requestLoop(url, portalData)
            }
          } else {
            this.$message({
              type: "error",
              message: "预览失败",
              customClass: "bigScreen_msg_backGroud",
              duration: 3000
            })
          }
        }
      })
    },
    buildModelForBigScreen(model) {
      for (let i in model) {
        if (i !== "event" && model[i] != null) {
          if (typeof model[i] == "object") {
            if (i === "chartOption") {
              this.fixChartFormatter(model[i])
              return
            } else this.buildModelForBigScreen(model[i])
          } else if (i === "layoutUidMap") {
            delete model[i]
          } else {
            if (i === "swiperMode" && model[i]) model[i] = false
            //处理formatter的富文本
            let needFix = this.handdleLengthUnitFix(model[i])
            if (PXRESEVERPROP.indexOf(i) > -1 && typeof model[i] !== "object") {
              model[i] = needFix ? model[i] + "px" : model[i]
            }
            if (i === "isActive" && model[i]) {
              model[i] = false
            }
          }
        }
      }
    },
    fixChartFormatter(model) {
      for (let k in model) {
        if (typeof model[k] === "object" && model[k] !== null && Object.keys(model[k]).length) {
          this.fixChartFormatter(model[k])
        } else {
          if (k === "formatter" && model[k] && model[k].includes("<")) {
            model.tempFormatter = model[k].split("")
          }
        }
      }
    },
    handdleLengthUnitFix(model) {
      let lengthUnit = null
      if (typeof model === "string") {
        lengthUnit = model.split("")
        lengthUnit = lengthUnit[model.length - 1]
      }
      if (lengthUnit === "%") {
        return false
      }
      return true
    },
    changeLockStatu() {
      this.isLock = !this.isLock
    },

    // 切换下拉选项
    changeSelectItem(key, index) {
      this[key] = index
    },
    handleCommand(index) {
      if (this.pageId === this.pagelist[index].publicId) {
        return
      }
      // 跳转到其他编辑页
      let oUrl = window.location.href
      let nUrl = oUrl.replace(/p=([^&]*)/gi, `p=${this.pagelist[index].publicId}`)
      window.location.href = nUrl
    },
    changeSize(size) {
      let pageSize = size.split("x")
      this.$emit("changeSize", pageSize)
    },
    openMyContainerSet() {
      //打开画布设置
      const activeID = {
        container_id: 0,
        rect_id: null
      }
      this.$store.commit("states/changeActiveID", activeID)
      this.$store.commit("states/changeToolBarStatus", true)
      this.$store.commit("states/changeElementType", "bigScreenContainer")
      // this.ids.container_id !== containerId && this.$store.commit("states/changeActiveID", activeID)
    },
    changeRulerStatu() {
      this.showRuler = !this.showRuler
    },
    replacePageClick() {
      this.replacePageDialog = true
      if (this.pageTemplates.length === 0) {
        this.getTemplateType()
        this.getTemplates()
      }
    },
    //获取页面模板类型
    getTemplateType() {
      let _this = this
      _this.$API.queryTemplateType().then(res => {
        _this.pageTemplateType = res.data.data
      })
    },
    changeTemplateType(type) {
      if (type.encId === this.activeTemplateId) {
        return
      }
      this.activeTemplateId = type.encId
      this.getTemplates()
    },
    //获取页面模板列表
    getTemplates: function () {
      let _this = this
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      this.$API
        .queryTemplateList({
          t: this.activeTemplateId
        })
        .then(res => {
          _this.pageTemplates = res.data.data.list
        })
    },
    selectSubPage(template) {
      this.pageTitle = template.name
      this.templatePageId = template.encId
      // this.getSubPageList(template.encId)
    },
    selectTemplatePage(template) {
      this.subTemplatePageId = template.encId
    },
    nextClick() {
      this.getSubPageList(this.templatePageId)
    },
    saveReplacePage(pageId) {
      let _this = this
      let templatePageId = pageId ? pageId : this.subTemplatePageId
      if (!templatePageId) {
        this.$message({
          type: "warning",
          duration: 3000,
          message: "请选择模版！"
        })
        return
      }
      this.$API
        .replacePage({
          w: this.websiteId,
          p1: this.pageId,
          p2: templatePageId
        })
        .then(res => {
          this.$message({
            type: "success",
            duration: 3000,
            message: "替换成功！"
          })
          window.location.reload()
        })
        .catch(res => {
          this.$message({ type: "error", customClass: "bigScreen_msg_backGroud", message: "替换失败！" })
        })
    },
    getSubPageList(encId) {
      let _this = this
      let contextPath = window.hasOwnProperty("p_contextpath") ? window["p_contextpath"] : ""
      this.$API
        .queryPageListByTemplateId({
          templateId: encId
        })
        .then(res => {
          _this.subPageTemplate = res.data.data.pageList
          if (_this.subPageTemplate?.length > 1) {
            _this.showSubPage = true
          } else {
            this.saveReplacePage(_this.subPageTemplate[0].encId)
          }
        })
    },
    // 接口返回状态码判断，是否是最新的版本
    isLatestVersion(data) {
      return !["mh_portal_50070", "mh_portal_50071"].includes(data)
    },
    //  处理所有的自由布局，将tab的选中项全部改为第一个
    handleTabActive(param) {
      if (!param.page || Object.keys(param.page).length === 0) return
      param.page.children.forEach(container => {
        container.children.forEach(rect => {
          if (rect.shape === "cxTabs") {
            rect.options.activeIndex = 0
            return
          }
          if (rect.shape !== "layoutComponentBigScreen") {
            return
          }
          rect.options.activeIndex = 0
          rect.options.titleOptions.forEach(title => {
            title.elementOptions.forEach(element => {
              if (element.innerElement === "cxTabs") {
                element.options.activeIndex = 0
              }
              if (element.innerElement === "cxTabs" && element.options.quoteTo === "cxTabs") {
                // tab(使用下拉框样式的时候，预览页切换到第一个选项)
                element.options.value = element.options.tabsList[0]?.name
                return
              }
              if (element.innerElement === "cxPagination") {
                element.options.value = 1
              }
            })
          })
        })
      })
    },
    // 页面离开的时候不调用自动保存
    pageTabChange() {
      document.addEventListener("visibilitychange", this.visibilityStateChange)
    },
    visibilityStateChange() {
      if (document.visibilityState == "visible") {
        this.isCurrentPage = true
        this.autoSave()
      } else if (document.visibilityState == "hidden") {
        this.isCurrentPage = false
        clearTimeout(this.autoSaveTimer)
      }
    },
    //大屏支持自动保存：
    autoSave() {
      // 开发环境不进行自动保存
      if (process.env.NODE_ENV === "development" || !this.isCurrentPage) {
        return
      }
      clearTimeout(this.autoSaveTimer)
      this.autoSaveTimer = setTimeout(() => {
        this.clickSave(undefined, true)
      }, 180000)
      // 三分钟进行保存一次
    },
    // 撤销
    goBackHandel() {
      if(this.canGoBack) {
        this.$undo()
      }
    },
    // 重做
    goNextHandel() {
      if(this.canGoNext) {
        this.$redo()
      }
    },
  },
  destroyed() {
    clearTimeout(this.autoSaveTimer)
    document.removeEventListener("visibilitychange", this.visibilityStateChange)
  }
}
</script>
<style scoped lang="scss">
.control-button {
  position: relative;
  min-width: 60px;
  padding: 0 10px;
  cursor: pointer;
  font-size: 14px;
  line-height: 21px;
  .icon {
    font-size: 20px;
  }
  .preview {
    width: 80px;
    height: 32px;
    padding: 0;
    line-height: 32px;
    color: var(--themeColor);
    border: 1px solid var(--themeColor);

    &:hover {
      background: rgba(61, 130, 242, 0.1);
    }
  }

  .save {
    width: 80px;
    padding: 0;
    height: 32px;
    line-height: 32px;
    background-color: var(--themeColor);
    border: 1px solid var(--themeColor);
    color: #fff;
    &:hover {
      background: var(--themeColorHover);
    }
  }

  .down-icon {
    position: absolute;
    right: 10px;
    top: 15px;
    transform: rotate(90deg);
  }
}
.pull-down-lists {
  position: absolute;
  background: #1f2124;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05),
    0px 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
  padding: 4px 0;
  width: 142px;
  .pull-down-list:hover {
    background-color: rgba(23, 112, 255, 0.1);
    // color: rgba(255, 255, 255, 0.8);
  }
  .pull-down-list {
    position: relative;
    padding: 10px 12px;
    text-align: left;
    color: rgba(255, 255, 255, 0.8);
    .icon {
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
      &:before {
        color: rgba(0, 0, 0, 0.8);
      }
    }
    p {
      display: inline-block;
      vertical-align: middle;
    }
    .selected-icon {
      display: inline-block;
      width: 12px;
      margin-right: 10px;
      color: var(--themeColor);
    }
    .right-icon {
      position: absolute;
      right: 12px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.mr10 {
  margin-right: 10px;
}
.el-dropdown-link {
  cursor: pointer;
}
::v-deep .replaceDialog {
  text-align: left;
  .el-dialog__body {
    padding: 16px 14px 16px 24px;
  }
}
.textColor {
  color: var(--textColor);
}
.templates-types {
  margin-top: 4px;
  > li {
    display: inline-block;
    margin-right: 8px;
    margin-top: 8px;
    cursor: pointer;
    color: var(--subTextColor);
    height: 24px;
    line-height: 24px;
    font-size: 13px;
    padding: 0 8px;
    border-radius: 37px;
    &.active {
      color: #ffffff;
      background: var(--themeColor);
    }
  }
}
.pages-styles {
  font-size: 0;
  margin-top: 15px;
  max-height: 400px;
  overflow-y: auto;
  > li {
    display: inline-block;
    vertical-align: top;
    margin-bottom: 16px;
    cursor: pointer;
    &:hover {
      .page-img {
        border: 2px solid var(--themeColor);
      }
    }
    &.active {
      .page-img {
        border: 2px solid var(--themeColor);
      }
    }
    &:not(:nth-child(3n)) {
      margin-right: 12px;
    }
  }
  p {
    font-size: 14px;
    line-height: 20px;
    text-align: center;
    word-break: break-all;
    max-width: 240px;
  }
  .cover-box {
    position: relative;
    width: 240px;
    height: 150px;
    text-align: center;
    border-radius: 8px;
    overflow: hidden;
    margin-bottom: 10px;
    .page-img {
      border-radius: 8px;
      border: 2px solid var(--borderColorFour);
    }
    .checked {
      position: absolute;
      right: 0;
      top: 0;
      width: 32px;
    }
  }
  .page-img {
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    object-fit: cover;
  }
  &.maxHeight500 {
    max-height: 500px;
  }
}
.marginTop0 {
  margin-top: 0;
}
.return-btn {
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  i {
    font-size: 24px;
    margin-right: 4px;
  }
}
</style>
